import * as React from 'react';

export const PlaceholderTrailerV2 = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 373.9" {...props}>
		<path fill="currentColor" d="M0 0h800v373.9H0z" data-name="Rechteck 1" opacity=".2" />
		<g fill="currentColor" data-name="Gruppe 2" opacity=".8">
			<path d="M171.2 124.9h582.7v5.8H171.2z" data-name="Rechteck 2" opacity=".6" />
			<path d="M245.7 130.6h12.4" data-name="Pfad 1" />
			<path d="M245.7 130.6h18" data-name="Pfad 2" />
			<path d="M492.3 200.4l-.3 1.6a6.8 6.8 0 00-.2 1.4h-.1z" data-name="Pfad 3" />
			<path d="M492.8 198.4l-.1.3a.4.4 0 00.1-.3z" data-name="Pfad 4" />
			<path d="M637 203.3h-6.4v-.1z" data-name="Pfad 5" />
			<path
				d="M740.3 130.6v59H633.7c-5.5-16.5-20-43-56.6-49.7a105.7 105.7 0 00-18.6-1.6 82.6 82.6 0 00-16.3 1.6c-33.1 6.8-48.6 33.7-55 49.7H173.9v-59z"
				data-name="Pfad 6"
				opacity=".2"
			/>
			<path
				d="M740.3 130.6v9.3H577.1a105.7 105.7 0 00-18.6-1.6 82.6 82.6 0 00-16.3 1.6H173.9v-9.3z"
				data-name="Pfad 7"
				opacity=".2"
			/>
			<path
				d="M379.9 197.6v14.2h-47.2v7.1h-87v-7.1H105.8v7.1h-8v66.9h-10v-66.9h-13v-7.1H35.6v-14.2h39.2v-7.3h13v-52.2h-13v-8.9h31v-19.1h10.6v28H97.8v52.2h8v7.3z"
				data-name="Pfad 8"
			/>
			<path
				d="M379.9 203.3v-5.7h-206v-8h313.4a95.3 95.3 0 00-4.3 13.6H379.9z"
				data-name="Pfad 9"
				opacity=".6"
			/>
			<path d="M492.3 200.4l-.3 1.6a6.8 6.8 0 00-.2 1.4h-.1z" data-name="Pfad 10" />
			<path d="M740.3 202.3v22.2h-12.9v-14.8H658v-7.4z" data-name="Pfad 11" />
			<path
				d="M740.3 189.7v12.6H658v1.1h-21a70.6 70.6 0 00-3.3-13.7h106.6z"
				data-name="Pfad 12"
				opacity=".6"
			/>
			<path d="M637 203.3h-6.4v-.1z" data-name="Pfad 13" />
			<path
				d="M495 191.2l-.3.9a51.5 51.5 0 00-2 7 .3.3 0 01-.1.2l.1-.5v-.1a.4.4 0 01.1-.3 1.4 1.4 0 01.2-.6 933044724937.7 933044724937.7 0 00.2-.6l.5-1.8a5.6 5.6 0 01.4-1.2l.3-1 .3-.9a4.5 4.5 0 01.3-1.1z"
				data-name="Pfad 15"
			/>
			<path
				d="M637 203.3l-6.4-.1a68.4 68.4 0 00-3.8-13.6 70.5 70.5 0 00-131.2 0l-.3.8a.3.3 0 01-.1.2l-.2.6-.4 1.1-.3.9-.3 1-.4 1.2-.5 1.8a.4.4 0 01-.1.3l-.1.3-.2.6-.1.3v.1l-.1.5v.4l-.1.2a.8.8 0 01-.1.4l-.6 3h-8.8a95.3 95.3 0 014.3-13.6c6.4-16 21.9-42.9 55-49.7a82.6 82.6 0 0116.3-1.6 106.6 106.6 0 0118.6 1.6 71.4 71.4 0 0156.6 49.7 70.7 70.7 0 013.3 13.6z"
				data-name="Pfad 16"
				opacity=".6"
			/>
			<g data-name="Gruppe 1">
				<path
					d="M630.6 203.3a69.3 69.3 0 00-3.8-13.7 70.5 70.5 0 00-131.2 0l-.3.8a.3.3 0 01-.1.2l-.2.6-.3.9a4.2 4.2 0 01-.4 1l-.3 1-.4 1.2-.5 1.8a.4.4 0 01-.1.3l-.1.3-.2.6-.1.3v.4a.3.3 0 01-.1.2v.4l-.1.2a.8.8 0 01-.1.4l-.3 1.6a6.8 6.8 0 00-.2 1.4 67.8 67.8 0 00-1 12 70.4 70.4 0 00140.8 0 68.3 68.3 0 00-1-11.9zm-69.4 55.4a43.4 43.4 0 01-41.7-55.4l.3-1.1a41.1 41.1 0 016.4-12.5 43.4 43.4 0 0176.6 13.3l.1.3a43.4 43.4 0 01-41.7 55.4zm4.6-98.2a69 69 0 00-44.6 9.9 69.7 69.7 0 00-19.2 18 62.9 62.9 0 01114.2-8.2 103.5 103.5 0 00-50.4-19.7z"
					data-name="Pfad 17"
				/>
				<path
					d="M616.2 180.1c-15-10.4-31.8-18-50.4-19.7a69 69 0 00-44.6 9.9 69.7 69.7 0 00-19.2 18 62.9 62.9 0 01114.2-8.2z"
					data-name="Pfad 18"
					opacity=".8"
				/>
				<path
					d="M602.9 203.3l-.1-.3a41.4 41.4 0 00-6.6-13.3 43.5 43.5 0 00-70 0 42.3 42.3 0 00-6.4 12.5l-.3 1.1a43.4 43.4 0 1083.4 0zm-41.7 49.9h-2.8l-1.3-.1h-.2l-1.1-.1a3.6 3.6 0 01-1-.2l-1-.2-1-.2-.4-.1a3 3 0 00-.9-.2l-1.4-.4a15.9 15.9 0 01-2-.7l-2.2-.9-1.1-.5a30.7 30.7 0 01-3.1-1.7l-2.7-1.8a5.5 5.5 0 01-.9-.7l-2.5-2.1-.9-.9a32.4 32.4 0 01-4.7-5.7l-.7-1a.1.1 0 00-.1-.1l-.4-.7-.4-.7-.9-1.7-.6-1.2a23.3 23.3 0 01-1.1-2.8l-.2-.5-.2-.5-.1-.3a1.9 1.9 0 01-.2-.7.8.8 0 01-.1-.5.9.9 0 01-.1-.5.4.4 0 00-.1-.3 17.4 17.4 0 01-.5-2.2l-.2-1.1a7.7 7.7 0 01-.2-1.5l-.2-1.6-.1-1.2v-1.9a36.8 36.8 0 012-12 4.9 4.9 0 01.4-1.1 37.9 37.9 0 0135.5-24.8h1.5a4.1 4.1 0 011.1.1 1.7 1.7 0 01.7.1l1.1.1a35.4 35.4 0 014.5.8l1.1.3.4.1 2 .6 2.3.9 2.2 1 1.5.8a9.1 9.1 0 011.3.8 10.5 10.5 0 011.1.7 5.5 5.5 0 01.9.7l.8.6a33.5 33.5 0 015.2 4.7 39 39 0 018 13.3l.1.4a36.8 36.8 0 012 12 38 38 0 01-38.1 37.4z"
					data-name="Pfad 19"
					opacity=".6"
				/>
				<path d="M525.6 228.4l1.1 2.8a23.3 23.3 0 00-1.1-2.8z" data-name="Pfad 20" />
				<path
					d="M597.1 203.3l-.1-.4a37.6 37.6 0 00-8-13.3 38.7 38.7 0 00-5.2-4.7l-.8-.6a5.5 5.5 0 01-.9-.7l-1.1-.7-1.3-.8-1.5-.8a21.4 21.4 0 00-2.2-1l-2.3-.9-2-.6-.4-.1-1.1-.3a35.4 35.4 0 00-4.5-.8l-1.1-.1a1.7 1.7 0 01-.7-.1 4.1 4.1 0 01-1.1-.1h-1.5a37.9 37.9 0 00-35.5 24.8 7.6 7.6 0 01-.4 1.1 36.8 36.8 0 00-2 12v1.9l.1 1.2a10 10 0 00.2 1.6l.2 1.5.2 1.1.5 2.2a.4.4 0 00.1.3l.1.5.1.5a1.9 1.9 0 01.2.7l.1.3.2.5.2.5 1.1 2.8.6 1.2.9 1.7.4.7.4.7a.1.1 0 00.1.1 8.7 8.7 0 00.7 1 43.2 43.2 0 004.7 5.7l.9.9 2.5 2.1a5.5 5.5 0 01.9.7 21.1 21.1 0 002.7 1.8 30.7 30.7 0 003.1 1.7l1.1.5 2.2.9 2 .7 1.4.4a3 3 0 00.9.2l.4.1a3.6 3.6 0 001 .2l1 .2 1 .2 1.1.1h.2l1.3.1h2.8a38 38 0 0037.9-37.9 31 31 0 00-1.8-11.5zm-66.2 15.6a3.4 3.4 0 01-2.7-1.3 3.6 3.6 0 011-5.4 3.3 3.3 0 011.7-.4 3.5 3.5 0 110 7.1zm26.6-34.1a3.6 3.6 0 017-.9 3 3 0 01.1 1 3.6 3.6 0 11-7.1-.1zm-20.8 6.8a3.5 3.5 0 015 0 5.5 5.5 0 01.7.9 3.5 3.5 0 01-5 4.6 3 3 0 01-.7-.5 3.5 3.5 0 010-5zm5.7 46.9a3.5 3.5 0 110-5 3.5 3.5 0 010 5zM561 248a3.6 3.6 0 113.6-3.6 3.5 3.5 0 01-3.6 3.6zm.2-14.2a18.5 18.5 0 01-18.5-18.5 18.2 18.2 0 014.5-12 3 3 0 01.8-.8 18 18 0 0113.2-5.6 18.5 18.5 0 0113.5 5.8 2.6 2.6 0 01.5.6 18 18 0 014.4 12 18.4 18.4 0 01-18.4 18.5zm22.6 4.9a3.5 3.5 0 110-5 3.5 3.5 0 010 5zm.7-42.3a3.5 3.5 0 110-5 3.5 3.5 0 010 5zm6 22.5a3.6 3.6 0 113.6-3.6 3.6 3.6 0 01-3.6 3.6z"
					data-name="Pfad 21"
					opacity=".8"
				/>
				<path
					d="M575.2 203.3a2.6 2.6 0 01-.5-.6 18.5 18.5 0 00-13.5-5.8 18 18 0 00-13.2 5.6 6 6 0 01-.8.8 18.2 18.2 0 00-4.5 12 18.5 18.5 0 0037 0 19.1 19.1 0 00-4.5-12zm-14 25.1a13.1 13.1 0 01-13.1-13.1 13 13 0 017.9-12 15.5 15.5 0 012.3-.8 13.6 13.6 0 012.9-.3 11.2 11.2 0 013.2.4 11.8 11.8 0 012 .7 13 13 0 01-5.2 25.1z"
					data-name="Pfad 22"
					opacity=".6"
				/>
				<path
					d="M574.3 215.3a13.1 13.1 0 11-26.2 0 13 13 0 017.9-12 15.5 15.5 0 012.3-.8 13.6 13.6 0 012.9-.3 11.2 11.2 0 013.2.4 11.8 11.8 0 012 .7 13.2 13.2 0 017.9 12z"
					data-name="Pfad 23"
					opacity=".8"
				/>
				<path
					d="M564.6 184.9a3.6 3.6 0 11-7.2 0v-.1a3.6 3.6 0 017-.9 4.4 4.4 0 01.2 1z"
					data-name="Pfad 24"
					opacity=".6"
				/>
				<path
					d="M564.6 244.5a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6z"
					data-name="Pfad 25"
					opacity=".6"
				/>
				<path
					d="M534.5 215.3a3.6 3.6 0 01-3.6 3.6 3.4 3.4 0 01-2.7-1.3 3.6 3.6 0 011-5.4 3.3 3.3 0 011.7-.4 3.6 3.6 0 013.6 3.5z"
					data-name="Pfad 26"
					opacity=".6"
				/>
				<path
					d="M594 215.3a3.6 3.6 0 11-3.6-3.6 3.6 3.6 0 013.6 3.6z"
					data-name="Pfad 27"
					opacity=".6"
				/>
				<path d="M584.5 196.4a3.5 3.5 0 110-5 3.5 3.5 0 010 5z" data-name="Pfad 28" opacity=".6" />
				<path d="M542.4 238.5a3.5 3.5 0 110-5 3.5 3.5 0 010 5z" data-name="Pfad 29" opacity=".6" />
				<path
					d="M541.7 196.6a3.4 3.4 0 01-4.3.5 3 3 0 01-.7-.5 3.5 3.5 0 015-5 5.5 5.5 0 01.7.9 3.7 3.7 0 01-.7 4.1z"
					data-name="Pfad 30"
					opacity=".6"
				/>
				<path d="M583.8 238.7a3.5 3.5 0 110-5 3.5 3.5 0 010 5z" data-name="Pfad 31" opacity=".6" />
			</g>
			<path d="M740.3 130.6H754v93.8h-13.7z" data-name="Rechteck 3" />
		</g>
	</svg>
);
